import { store } from 'index' 

const getFeedBack = () => {

    const state = store.getState();
    const componentsState = state.components
    
    if ( componentsState.success ) {
        return 'כל הכבוד!'
    }
    if ( componentsState.failurCount === 1 ) {
     return 'נסו שוב'
    }
    if ( componentsState.failurCount === 2 ) {
     return 'נסו שוב'
    }
    return ''
 }

export default getFeedBack